import { BRAND } from "@/lib/config";

/**
 * Renders the VISION wordmark as pure typography via a luminance CSS mask.
 * The uploaded logo has a solid black background baked in; using it as a
 * luminance mask lets the white marks (VISION + globe) show through in any
 * color, on any background, with no visible rectangle.
 */
export default function Logo({
  className = "h-10 w-40",
  color = "#f2ede3",
  ariaLabel = "VISION",
  ...rest
}) {
  const url = BRAND.logoUrl;
  return (
    <span
      role="img"
      aria-label={ariaLabel}
      className={`inline-block ${className}`}
      style={{
        backgroundColor: color,
        WebkitMaskImage: `url("${url}")`,
        maskImage: `url("${url}")`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskMode: "luminance",
        maskMode: "luminance",
      }}
      {...rest}
    />
  );
}
